import React, { createContext, useContext, useState, useEffect } from 'react';

const SearchContext = createContext();

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  // Global search state
  const [searchState, setSearchState] = useState({
    from: 'BLR',
    to: 'DEL',
    startDate: new Date().toISOString().split('T')[0],
    endDate: '',
    adults: 1,
    children: 0,
    infants: 0,
    travelClass: 'ECONOMY',
    currencyCode: 'INR',
    maxPrice: 100000,
    max: 250
  });

  // Update search parameters
  const updateSearchParams = (newParams) => {
    setSearchState(prev => ({
      ...prev,
      ...newParams
    }));
  };

  // Update specific parameter
  const updateParam = (key, value) => {
    setSearchState(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Get current search parameters for API calls
  const getFlightParams = () => {
    const params = {
      originLocationCode: searchState.from,
      destinationLocationCode: searchState.to,
      departureDate: searchState.startDate,
      adults: searchState.adults,
      children: searchState.children,
      infants: searchState.infants,
      travelClass: searchState.travelClass,
      currencyCode: searchState.currencyCode,
      maxPrice: searchState.maxPrice,
      max: 250
    };
    
    if (searchState.endDate) {
      params.returnDate = searchState.endDate;
    }

    if (searchState.tripType) {
      params.tripType = searchState.tripType;
    }

    if (searchState.tripType === 'multicity' && Array.isArray(searchState.multiCitySegments)) {
      params.segments = searchState.multiCitySegments;
      params.journeyType = 3;
    }
    
    return params;
  };

  // Initialize from URL params if available
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');
    const to = urlParams.get('to');
    const startDate = urlParams.get('startDate');
    const endDate = urlParams.get('endDate');
    const adults = urlParams.get('adults');
    const children = urlParams.get('children');
    const infants = urlParams.get('infants');
    const travelClass = urlParams.get('class');

    if (from || to || startDate || endDate || adults || children || infants || travelClass) {
      updateSearchParams({
        from: from || searchState.from,
        to: to || searchState.to,
        startDate: startDate || searchState.startDate,
        endDate: endDate || searchState.endDate,
        adults: adults ? parseInt(adults) : searchState.adults,
        children: children ? parseInt(children) : searchState.children,
        infants: infants ? parseInt(infants) : searchState.infants,
        travelClass: travelClass || searchState.travelClass
      });
    }
  }, []);

  const value = {
    searchState,
    updateSearchParams,
    updateParam,
    getFlightParams
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}; 